<div class="auth-page bg-ggm position-relative overflow-hidden">
  <app-auth-header />

  <div class="wave-background-container">
    <div class="wave-layer wave-layer-1"></div>
    <div class="wave-layer wave-layer-2"></div>
    <div class="wave-layer wave-layer-3"></div>
  </div>

  <div class="auth-page__body container-fluid position-relative z-index-content">
    <div class="auth-page__center" [class.auth-page__center--register]="view === 'REGISTER'">
      @switch (view) {
        @case ('LOGIN') {
          <app-login class="auth-form" />
        }
        @case ('REGISTER') {
          <app-register class="auth-form auth-form--wide w-100" />
        }
        @case ('RECOVERY_PASSWORD') {
          <app-recovery-password class="auth-form" />
        }
      }
    </div>
  </div>
</div>
